import React, { useState, useEffect } from "react";
import Auth from "../../utils/auth";
import { API_URL } from "../../api/APIUrl";

const AdminUsers = ({ visible }) => {
  const [users, setUsers] = useState([]);
  const [posts, setPosts] = useState([]);
  const [username, setUsername] = useState("");

  function getAllUsers() {
    fetch(`${API_URL}/api/users`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((r) => r.json())
      .then((data) => setUsers(data));
  }

  function getUser() {
    fetch(`${API_URL}/api/users/${Auth.userId()}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((r) => r.json())
      .then((data) => setUsername(data.username));
  }

  function getAllMaterials() {
    fetch(`${API_URL}/api/materials`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((r) => r.json())
      .then((data) => setPosts(data.data.reverse()));
  }

  useEffect(() => {
    getAllUsers();
    getAllMaterials();
    getUser();
  }, []);

  // --- DYNAMIC DATA CALCULATIONS ---
  const adminCount =
    users.filter((u) => u.role?.toLowerCase() === "admin" || u.isAdmin)
      .length || 1;

  // --- MODERN GRID LAYOUT STYLES ---
  const containerStyle = {
    display: visible === false ? "none" : "flex",
    flexDirection: "column",
    padding: "60px 40px",
    fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
    backgroundColor: "#fafbfc",
    minHeight: "100vh",
    width: "100%",
    boxSizing: "border-box",
    alignItems: "center",
  };

  const workspaceWrapperStyle = {
    width: "100%",
    maxWidth: "1200px",
    display: "flex",
    flexDirection: "column",
    gap: "40px",
  };

  const headerGroupStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  };

  const greetingTextStyle = {
    fontSize: "36px",
    fontWeight: "800",
    color: "#0f172a",
    margin: 0,
    letterSpacing: "-0.5px",
  };

  const subtitleTextStyle = {
    fontSize: "16px",
    color: "#64748b",
    margin: 0,
    fontWeight: "500",
  };

  const cardGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)", // Clean, intentional 3-column split
    gap: "28px",
    width: "100%",
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    border: "1px solid #eef2f6",
    borderRadius: "24px",
    padding: "32px 28px",
    display: "flex",
    alignItems: "center",
    gap: "24px",
    boxShadow:
      "0 10px 25px -5px rgba(15, 23, 42, 0.03), 0 4px 12px -2px rgba(15, 23, 42, 0.02)",
    transition:
      "transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s ease",
  };

  const iconWrapperStyle = (bgColor) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "72px",
    height: "72px",
    borderRadius: "20px",
    backgroundColor: bgColor,
    flexShrink: 0,
  });

  const infoGroupStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  };

  const labelStyle = {
    fontSize: "13px",
    fontWeight: "700",
    color: "#94a3b8",
    textTransform: "uppercase",
    letterSpacing: "0.75px",
  };

  const metricValueStyle = {
    fontSize: "42px",
    fontWeight: "800",
    color: "#0f172a",
    margin: 0,
    lineHeight: 1,
    letterSpacing: "-1px",
  };

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap"
        rel="stylesheet"
      />
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons+Sharp"
        rel="stylesheet"
      />

      <div style={containerStyle}>
        <div style={workspaceWrapperStyle}>
          {/* HEADER GREETING ZONE */}
          <div style={headerGroupStyle}>
            <h1 style={greetingTextStyle}>
              Welcome Back, {username || "MARKETING"}!
            </h1>
            <p style={subtitleTextStyle}>
              Here is an overview of your platform statistics and system metrics
              for today.
            </p>
          </div>

          {/* PERFECTED 3-COLUMN METRIC SYSTEM */}
          <div style={cardGridStyle}>
            {/* 1. Total Users */}
            <div
              style={cardStyle}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 25px -5px rgba(0, 0, 0, 0.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow =
                  "0 10px 25px -5px rgba(15, 23, 42, 0.03)";
              }}
            >
              <div style={iconWrapperStyle("#e7f1ff")}>
                <span
                  className="material-icons-sharp"
                  style={{ color: "#007bff", fontSize: "36px" }}
                >
                  people_alt
                </span>
              </div>
              <div style={infoGroupStyle}>
                <span style={labelStyle}>Total Users</span>
                <h2 style={metricValueStyle}>{users.length}</h2>
              </div>
            </div>

            {/* 2. Total Materials */}
            <div
              style={cardStyle}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 25px -5px rgba(0, 0, 0, 0.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow =
                  "0 10px 25px -5px rgba(15, 23, 42, 0.03)";
              }}
            >
              <div style={iconWrapperStyle("#fff7ed")}>
                <span
                  className="material-icons-sharp"
                  style={{ color: "#f97316", fontSize: "36px" }}
                >
                  auto_stories
                </span>
              </div>
              <div style={infoGroupStyle}>
                <span style={labelStyle}>Total Material</span>
                <h2 style={metricValueStyle}>{posts.length}</h2>
              </div>
            </div>

            {/* 3. Administrators */}
            <div
              style={cardStyle}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                  "0 20px 25px -5px rgba(0, 0, 0, 0.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow =
                  "0 10px 25px -5px rgba(15, 23, 42, 0.03)";
              }}
            >
              <div style={iconWrapperStyle("#f3e8ff")}>
                <span
                  className="material-icons-sharp"
                  style={{ color: "#a855f7", fontSize: "36px" }}
                >
                  admin_panel_settings
                </span>
              </div>
              <div style={infoGroupStyle}>
                <span style={labelStyle}>Administrators</span>
                <h2 style={metricValueStyle}>{adminCount}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminUsers;
